import { useMemo } from "react";
import { useLocation, Link } from "react-router-dom";

function useQuery() {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
}

export default function PaymentResult() {
    const q = useQuery();
    const status = q.get("status");
    const oid = q.get("oid");
    const msg = q.get("msg");

    return (
        <div>
            <h1>{status === "success" ? "Payment Successful" : "Payment Failed"}</h1>
            <p>{msg}</p>
            <p>Order ID: {oid}</p>

            {status === "success" ? (
                <Link to={`/orders/${oid}`}>View Receipt</Link>
            ) : (
                <Link to="/checkout">Try Again</Link>
            )}
        </div>
    );
}
